import { defineNuxtRouteMiddleware } from '#imports'

import { useFetchPickersInternal } from '~/scopes/product-core/composables/useFetch/useFetchPickers/composables/useFetchPickersInternal'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

export default defineNuxtRouteMiddleware(
  async function blockClientNavigation(to) {
    if (import.meta.client) {
      await Promise.all([useFetchProduct(to), useFetchPickersInternal(to)])
    }
  },
)
